import type { FC } from "react";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Banner } from "@similarweb/ui-components";
import { SWReactIcons } from "@similarweb/icons";
import { EMPTY_CUSTOM_SEGMENTS } from "app/services/segments/segmentsApiService";
import { useSelector } from "react-redux";
import type { IMeteringRawData } from "app/components/metering/types";
import { fetchSegmentsMeteringData, getBannerTitle } from "../../metering/SegmentsMetering";
import { PlainTooltip } from "@similarweb/ui-components";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { translate } from "app/filters/i18nFilter";

const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const Title = styled.span`
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
`;

const IconsWrapper = styled(CenteredFlexRow)``;

const LimitationDisclaimer: FC = () => {
    const [title, setTitle] = useState<string>();

    const { customSegmentsMeta = EMPTY_CUSTOM_SEGMENTS } = useSelector((state) => {
        const {
            segmentsModule: { segmentsLoading, customSegmentsMeta },
        } = state;
        return { segmentsLoading, customSegmentsMeta };
    });

    useEffect(() => {
        fetchSegmentsMeteringData().then((rawData: IMeteringRawData) => {
            const title = getBannerTitle(rawData);
            if (title) {
                setTitle(title);
            }
        });
    }, [customSegmentsMeta]);

    return (
        <>
            {title ? (
                <div data-automation="LimitationDisclaimer">
                    <Banner
                        title={
                            <TitleContainer>
                                <Title>{title}</Title>
                                <PlainTooltip
                                    tooltipContent={translate("segments.metering.limitation.disclaimer.tooltip")}
                                >
                                    <IconsWrapper>
                                        <SWReactIcons
                                            size="xs"
                                            iconName="info-full"
                                            iconColor={colorsPalettes.carbon["200"]}
                                        />
                                    </IconsWrapper>
                                </PlainTooltip>
                            </TitleContainer>
                        }
                        CustomIcon={
                            <SWReactIcons
                                iconName="spend"
                                size="sm"
                            />
                        }
                    />
                </div>
            ) : null}
        </>
    );
};

export default LimitationDisclaimer;
